import React from "react";
import tostyles from "../styles/toggler.module.css";

function Toggler({tooglerStatus,setTooglerStatus, togHeadline}){
 const handleToggle =( toggle) =>{
   setTooglerStatus(toggle);

 }

    return(
        <section className={tostyles.togglersection}>

            <ul className={tostyles.tolist}>
<li className={tostyles.headline}>{togHeadline}</li>
                <li
                    className={

                    tooglerStatus === "female"
                        ? tostyles.activelist
                        : ""

                    }
            onClick={()=>handleToggle("female")}
                >
                    Frau

                </li>



                    <li
                        className={

                            tooglerStatus === "male"
                                ? tostyles.activelist
                                : ""

                        }
                        onClick={()=>handleToggle("male")}

                    >
                        Mann
                    </li>


            </ul>



</section>



    )
}
export default Toggler;